(function () {
  var root = document.querySelector('.sn-pdp');
  if (!root) return;

  var SUB_DISCOUNT = 0.9;
  var CUTOFF_HOUR = 14;
  var state = {
    cans: Number(root.dataset.cans || 12),
    base: Number(root.dataset.price || 0) / 100,
    plan: 'once',
    qty: 1
  };
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var phone = window.matchMedia('(max-width: 749px)');
  var gbp = function (n) { return '£' + n.toFixed(2); };
  var $ = function (s) { return root.querySelector(s); };
  var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };

  $$('[data-sugar]').forEach(function (el) {
    var n = Number(el.getAttribute('data-sugar') || 0);
    var html = '';
    for (var i = 0; i < n; i++) html += '<i></i>';
    el.innerHTML = html;
  });

  var boxes = function (n) { return n + (n === 1 ? ' box' : ' boxes'); };
  var each = function () { return state.plan === 'sub' ? state.base * SUB_DISCOUNT : state.base; };

  function shipCopy(sub) {
    return sub ? 'delivery’s free on subscriptions. very snobby of you.' : 'uk delivery £1. yes, a quid.';
  }

  function render() {
    var price = each();
    var total = price * state.qty;
    var perCan = gbp(price / state.cans) + ' a can';
    var priceEl = $('[data-price]');
    if (priceEl) priceEl.textContent = gbp(total);
    var was = $('[data-was]');
    if (was) {
      was.hidden = state.plan !== 'sub';
      was.textContent = gbp(state.base);
    }
    var unit = $('[data-unit]');
    if (unit) unit.textContent = perCan;
    var qtyOut = $('[data-qty-out]');
    if (qtyOut) qtyOut.textContent = state.qty;
    var qtyInput = $('[data-qty-input]');
    if (qtyInput) qtyInput.value = state.qty;
    $$('[data-atc-total]').forEach(function (el) { el.textContent = gbp(total); });
    var stickyMeta = $('[data-sticky-meta]');
    if (stickyMeta) stickyMeta.textContent = boxes(state.qty) + ' · ' + perCan;
    var stickyTotal = $('[data-sticky-total]');
    if (stickyTotal) stickyTotal.textContent = gbp(total);
    var shipMsg = $('[data-ship-msg]');
    if (shipMsg) shipMsg.textContent = shipCopy(state.plan === 'sub');
  }

  function addWorkingDays(date, n) {
    var d = new Date(date);
    while (n > 0) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() % 6) n--;
    }
    return d;
  }

  function renderEta() {
    var eta = $('[data-eta]');
    if (!eta) return;
    var now = new Date();
    var weekday = now.getDay() % 6 !== 0;
    var beforeCutoff = weekday && now.getHours() < CUTOFF_HOUR;
    var dispatch = beforeCutoff ? now : addWorkingDays(now, 1);
    var arrive = addWorkingDays(dispatch, 2);
    var day = arrive.toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'short' }).toLowerCase();
    var tail;
    if (beforeCutoff) {
      var mins = CUTOFF_HOUR * 60 - (now.getHours() * 60 + now.getMinutes());
      tail = 'order in the next ' + (mins >= 60 ? Math.floor(mins / 60) + 'h ' : '') + (mins % 60) + 'm for dispatch today.';
    } else {
      tail = 'dispatched next working day.';
    }
    eta.innerHTML = 'get it by <b>' + day + '</b>. ' + tail;
  }

  $$('[data-qty]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      state.qty = Math.max(1, Math.min(10, state.qty + Number(btn.dataset.qty)));
      render();
    });
  });

  function scrollToBuy() {
    var row = $('.atc-row');
    if (row) row.scrollIntoView({ block: 'center', behavior: reduceMotion.matches ? 'auto' : 'smooth' });
  }
  var stickyChange = $('[data-sticky-change]');
  if (stickyChange) stickyChange.addEventListener('click', scrollToBuy);

  var added = $('[data-added]');
  var form = $('[data-sn-pdp-form]');

  function showAdded(n, line, cartTotal) {
    if (!added) return;
    $('[data-added-meta]').textContent = boxes(n) + ' of 12';
    $('[data-added-line]').textContent = gbp(line);
    $('[data-added-total]').textContent = gbp(cartTotal);
    $('[data-added-ship]').textContent = shipCopy(false);
    if (typeof added.showModal === 'function') added.showModal();
  }

  function addToBag(qty) {
    var n = Math.max(1, Number(qty) || 1);
    state.qty = n;
    render();
    if (!form) return;
    var data = new FormData(form);
    data.set('quantity', String(n));
    fetch(form.action, {
      method: 'POST',
      headers: { Accept: 'application/javascript' },
      body: data
    })
      .then(function (res) { return res.json(); })
      .then(function () {
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        showAdded(n, each() * n, (cart.total_price || 0) / 100);
        document.dispatchEvent(new CustomEvent('cart:update', { detail: { cart: cart } }));
      })
      .catch(function () {
        form.submit();
      });
  }

  $$('[data-set-qty]').forEach(function (btn) {
    btn.addEventListener('click', function () { addToBag(Number(btn.dataset.setQty)); });
  });
  $$('[data-atc]').forEach(function (btn) {
    btn.addEventListener('click', function (event) {
      event.preventDefault();
      addToBag(state.qty);
    });
  });
  $$('[data-added-close]').forEach(function (btn) {
    btn.addEventListener('click', function () { if (added) added.close(); });
  });
  var checkoutBtn = $('[data-added-checkout]');
  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', function (event) {
      event.preventDefault();
      var url = checkoutBtn.getAttribute('data-checkout-url') || '/checkout';
      if (added) added.close();
      try {
        window.top.location.assign(url);
      } catch (err) {
        window.location.assign(url);
      }
    });
  }
  if (added) {
    added.addEventListener('click', function (e) { if (e.target === added) added.close(); });
  }

  var track = $('[data-track]');
  var slides = $$('.slide');
  var thumbs = $$('.thumb');
  var current = 0;
  var dragged = false;
  function setCurrent(i) {
    current = i;
    thumbs.forEach(function (t, n) {
      if (n === i) t.setAttribute('aria-current', 'true');
      else t.removeAttribute('aria-current');
    });
    var count = $('[data-count]');
    if (count) count.textContent = (i + 1) + ' / ' + slides.length;
  }
  function goTo(i) {
    if (!track || !slides.length) return;
    i = (i + slides.length) % slides.length;
    track.scrollTo({ left: i * track.clientWidth, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
    setCurrent(i);
  }
  if (track && slides.length) {
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        setCurrent(Math.round(track.scrollLeft / Math.max(track.clientWidth, 1)));
        ticking = false;
      });
    });
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goTo(i); }); });
    $$('[data-gallery-step]').forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        goTo(current + Number(btn.getAttribute('data-gallery-step')));
      });
    });
    var zoomHint = $('.gallery__zoom');
    if (zoomHint) setTimeout(function () { zoomHint.classList.add('is-faded'); }, 4000);
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current - 1); }
      if (e.key === 'Enter') openZoom(current);
    });
    var pointerX = 0;
    track.addEventListener('pointerdown', function (event) {
      pointerX = event.clientX;
      dragged = false;
    });
    track.addEventListener('pointermove', function (event) {
      if (Math.abs(event.clientX - pointerX) > 10) dragged = true;
    });
  }

  var zoom = $('[data-zoom]');
  var zoomImg = $('[data-zoom-img]');
  var stage = $('[data-zoom-stage]');
  var zoomIndex = 0;
  function showZoom(i) {
    if (!slides.length || !zoomImg) return;
    zoomIndex = (i + slides.length) % slides.length;
    var img = slides[zoomIndex].querySelector('img');
    zoomImg.src = img.currentSrc || img.src;
    zoomImg.alt = img.alt;
    zoomImg.classList.toggle('is-contain', img.classList.contains('is-contain'));
    zoomImg.classList.toggle('is-vibe', img.classList.contains('is-vibe'));
    if (zoom) zoom.classList.remove('is-zoomed');
    var zc = $('[data-zoom-count]');
    if (zc) zc.textContent = (zoomIndex + 1) + ' / ' + slides.length;
  }
  function openZoom(i) {
    if (!zoom || typeof zoom.showModal !== 'function') return;
    showZoom(i);
    zoom.showModal();
  }
  function toggleZoom(x, y) {
    if (!zoom || !zoomImg || !stage) return;
    var rect = zoomImg.getBoundingClientRect();
    var fx = (x - rect.left) / rect.width;
    var fy = (y - rect.top) / rect.height;
    var on = zoom.classList.toggle('is-zoomed');
    var hint = $('[data-zoom-hint]');
    if (hint) hint.textContent = on ? 'drag to look around · double-tap to zoom out' : 'double-tap or pinch to zoom';
    if (on) {
      stage.scrollLeft = fx * zoomImg.offsetWidth - stage.clientWidth / 2;
      stage.scrollTop = fy * zoomImg.offsetHeight - stage.clientHeight / 2;
    }
  }
  slides.forEach(function (s, i) {
    s.addEventListener('click', function () {
      if (dragged) return;
      openZoom(i);
    });
  });
  if (zoomImg) {
    var lastTap = 0;
    zoomImg.addEventListener('pointerup', function (e) {
      if (e.pointerType === 'mouse') { toggleZoom(e.clientX, e.clientY); return; }
      var now = Date.now();
      if (now - lastTap < 320) { toggleZoom(e.clientX, e.clientY); lastTap = 0; } else lastTap = now;
    });
  }
  var zoomClose = $('[data-zoom-close]');
  if (zoomClose && zoom) zoomClose.addEventListener('click', function () { zoom.close(); });
  $$('[data-zoom-step]').forEach(function (b) {
    b.addEventListener('click', function () { showZoom(zoomIndex + Number(b.dataset.zoomStep)); });
  });
  if (zoom) {
    zoom.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') showZoom(zoomIndex + 1);
      if (e.key === 'ArrowLeft') showZoom(zoomIndex - 1);
    });
    zoom.addEventListener('close', function () { goTo(zoomIndex); });
  }

  function syncDetails() {
    $$('[data-desktop-open]').forEach(function (d) { d.open = !phone.matches; });
  }
  if (phone.addEventListener) phone.addEventListener('change', syncDetails);
  syncDetails();

  var sticky = $('[data-sticky]');
  var atcVisible = true;
  var thumbsVisible = true;
  var footerVisible = false;
  function syncSticky() {
    if (!sticky) return;
    var show = !atcVisible && !thumbsVisible && !footerVisible;
    sticky.classList.toggle('is-visible', show);
    sticky.inert = !show;
  }
  if ('IntersectionObserver' in window && sticky) {
    var atcRow = $('.atc-row');
    var thumbsEl = $('.gallery__thumbs');
    var footer = document.querySelector('.sn-footer, footer-group, #footer-group');
    if (atcRow) new IntersectionObserver(function (entries) { atcVisible = entries[0].isIntersecting; syncSticky(); }).observe(atcRow);
    if (thumbsEl) new IntersectionObserver(function (entries) { thumbsVisible = entries[0].isIntersecting; syncSticky(); }).observe(thumbsEl);
    if (footer) new IntersectionObserver(function (entries) { footerVisible = entries[0].isIntersecting; syncSticky(); }).observe(footer);
  }

  render();
  renderEta();
})();
